import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'


const _withScopeId = n => (_pushScopeId("data-v-98b80bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))

import { RouteLocationRaw, useRouter } from 'vue-router';

  interface IProps {
    to?: RouteLocationRaw
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    to: null
  },
  setup(__props: any) {

const props = __props as {
    to?: RouteLocationRaw
  }

  const router = useRouter();
  

  function handleNav() {
    if (props.to) {
      router.replace(props.to);
    } else {
      router.go(-1);
    }
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "component-back",
    onClick: handleNav
  }, [
    _hoisted_1,
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})